import React from 'react'
import DocWithId from '../Components/Appointment/DocWithId'

const Appointment = () => {
    return (
        <>
            <DocWithId />

        </>
    )
}

export default Appointment
